/**
 * Presents explicit collaborator changes for one Vault item lineage.
 *
 * Sharing is an authorization decision, not ordinary metadata editing. The
 * dialog delegates candidate lookup and grant invariants to VaultAccessManager
 * and never infers access from workspace visibility.
 */
import type { NodeApiClient } from '@/app-shell/api/node-api-client'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import type { ItemResponse } from '../types'
import { VaultAccessManager } from './VaultAccessManager'

export function ShareDialog({
  api,
  orgId,
  vaultId,
  entry,
  onClose,
}: {
  api: NodeApiClient
  orgId: string
  vaultId: string
  entry: ItemResponse | null
  onClose: () => void
}) {
  return (
    <Dialog
      open={entry !== null}
      onOpenChange={open => { if (!open) onClose() }}
    >
      <DialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="break-words pr-8 leading-tight">
            Share ‘{entry?.item.name}’
          </DialogTitle>
          <DialogDescription>
            Manage access to this Vault item.
          </DialogDescription>
        </DialogHeader>
        {entry && (
          <VaultAccessManager
            api={api}
            orgId={orgId}
            vaultId={vaultId}
            itemId={entry.item.itemId}
            readOnly={entry.item.readOnly}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
